"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCrossedPlane = function SvgCrossedPlane(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 64,
    height: 62,
    id: "crossed-plane_svg__a",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA+CAMAAACsn+1dAAAAAXNSR0IB2cksfwAAAMlQTFRF////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALJMpoAAAAEN0Uk5TAE1oSof/+y03xwHlaZfwGEepBvFJp98KV4kO+S63AmcZ/ncn1zAqzVSEIzvMBwPvlKphDenQ+L2FIs/0XYb6MT2wBMzkWToAAAFhSURBVHicrZfpVsIwEIVRCFCQCiiKgopoAfd9XxDe/6GgadJG0ga81/nJzPnOML2ZJZezbW09tHyKZ0UriNCKJRhQlgDhVVBApRoRNuAUahHA30QB9QggGiiguaUI2yihpQA7uyCgrQBiDwTsdxSg2AUJBzoF7xADHGkAKobesQb4PYzgxSmAYujHAFAMJwkAFMNpQsDEUEgAmBjKCcAthm4QBIOU33VTWCqGYRgwSnHUDIBLDGcy4Nx21A2ASwwXMuDyynLETWGJGK5vZMCt7WmZAIcY7qIIuwxtE+AQw72qk1WGh44JyBaDfniPT4v2/CsF2//y+iYJ7wK2j88Q8IUDxPd4DvghAGIyB0x9AlD9DwD9F+gisp+RFhItZfYx0c+Zbih0S6ObKt3Ws2zlwZJl9Ghjhys93ukFg11x6CWLXvPYRZNedellm1336YODPnnYo4s+++jDkz59/3R8zwBQ6jq/22r28wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("use", {
    href: "#crossed-plane_svg__a",
    y: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4 61.8 1.6 59 59.4 1.5l2.8 2.8z",
    style: {
      fill: 'red'
    }
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCrossedPlane);
var _default = exports["default"] = Memo;